// extracted by mini-css-extract-plugin
export var arrows = "_47-6";
export var decrementer = "_47-a";
export var disabled = "_47-4";
export var error = "_47-1";
export var hiddenText = "_47-b";
export var incrementer = "_47-9";
export var input = "_47-8";
export var inputWrapper = "_47-0";
export var leadingIcon = "_47-c";
export var readonly = "_47-3";
export var regular = "_47-7";
export var small = "_47-5";
export var warning = "_47-2";